import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-portrait',
  templateUrl: './no-portrait.component.html',
  styleUrls: ['./no-portrait.component.scss']
})
export class NoPortraitComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
